import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/advertiser/agent/list' // 광고목록 조회

const fetchKey = (page, maxData, address) =>
	`${M_KEY}?${page && 'page=' + page}${maxData && '&maxData=' + maxData}${address && '&address=' + address}`;

export function useAdvertiserAgentList(page=1, maxData=10, address='') {
	const { data: token } = useToken();

	const KEY = fetchKey(page, maxData, address);


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { advertiserAgentList: data?.list, mutateAdvertiserAgentList: mutate, total: data?.total };
}

async function fetchAPI(KEY:string, token:any): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return {list: response.result?.result?.list || [], total: response.result?.result?.totalCount}
	} catch (error) {
		console.error('Failed to fetch Advertiser Agent List:', error);
		return { list: [], total: 0 };
	}
}